import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { registerBlocker, unregisterBlocker } from "@/redux/navigation/reducer";

/**
 * Hook for shared to use for blocking navigation on unsaved changes
 *
 * @param isDirty - Whether the component has unsaved changes
 * @param componentId - Unique ID for the component
 */
export function useNavigationBlocker(isDirty: boolean, componentId: string) {
  const dispatch = useDispatch();
  const id =
    componentId || `blocker-${Math.random().toString(36).substring(2, 9)}`;

  useEffect(() => {
    dispatch(registerBlocker({ id, shouldBlock: isDirty }));

    return () => {
      dispatch(unregisterBlocker(id));
    };
  }, [dispatch, id, isDirty]);

  return id;
}
